import SuccessRates from "./SuccessRates";

export default class ProfileStatsModel {
    public profileId: string;
    public tier: string;
    public points: number;
    public successRates: SuccessRates = new SuccessRates();
}